<template>
  <div class="courseWrap">
    <v-sheet class="pa-4 lighten-2">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="请输入课程名称"
        single-line
        hide-details
        @keydown="keydownSearch"
        style="padding-top: 0px"
      ></v-text-field>
      <md-tooltip md-direction="top">按回车以检索</md-tooltip>
    </v-sheet>
    <div class="md-layout thirdPartySoftListWrap">
      <div
        v-for="item in thirdPartySoftList"
        class="mt-3"
        cols="auto"
        :key="item._id"
        :class="
          isMobile.isMobile
            ? 'thirdPartySoftList courseList'
            : 'md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseList'
        "
        :max-height="isMobile.isMobile ? '105' : '245'"
        :height="isMobile.isMobile ? '105' : '245'"
      >
        <v-card
          elevation="2"
          class="cardWrap"
          :max-height="isMobile.isMobile ? '105' : '245'"
          :height="isMobile.isMobile ? '105' : '245'"
        >
          <v-img
            :lazy-src="item.cover ? item.cover : scoureImg"
            class="coureListImg"
            :height="isMobile.isMobile ? '80px' : '190px'"
            :max-height="isMobile.isMobile ? '80px' : '190px'"
            max-width="100%"
            :src="item.cover ? item.cover : scoureImg"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="rightTag">
            <div class="selectWrapAdd">
              <v-btn @click.stop icon>
                <v-icon style="color: #fff">mdi-dots-vertical</v-icon>
              </v-btn>
              <div class="selectContent">
                <p
                  v-for="(items, index) in editList"
                  :key="index"
                  @click.stop="goToSetting(item, items)"
                >
                  <span>{{ items.title }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="coureNameWrap">
            <span class="ml-2">{{ item.name }}</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="mr-1"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  text
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(text, index) in ['编辑', '模型', '考核配置', '版本更新']"
                  :key="index"
                  @click="
                    text === '编辑' ? handleEdit(item) :
                    text === '模型' ? handleModel(item) :
                    text === '版本更新' ? handleOpenUpdateDialog(item) :
                    handleExamConfig(item)
                  "
                  link
                >
                  <v-list-item-title>{{ text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div class="editWrap">
            <div style="width: 100%; height: 180px; overflow: hidden">
              <div class="leftTag">
                <p class="tagKey">
                  <span>负责人</span>
                  : {{ item.manager || '' }}
                </p>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <div
        v-if="!thirdPartySoftListLoading && thirdPartySoftList.length === 0"
        style="width: 100%; text-align: center"
        class="text-grey"
      >
        暂无数据
      </div>
    </div>

    <div style="margin-top: 0px; margin-bottom: 20px">
      <div style="overflow: hidden">
        <Pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :items-per-page.sync="pagination.itemsPerPage"
          @refresh="queryData"
          style="text-align: right"
        />
      </div>
    </div>
    <ModelCheckDialog :dialogModel.sync="dialogModel" :queryFunction="queryModelData" :relationId="currentCourseId" />
    <ExamConfigDialog :dialogExamConfig.sync="dialogExamConfig" :treeData="treeData" />

    <v-dialog v-model="dialogStatus" max-width="800" transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <div class="d-flex align-end my-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>
          <span class="h4 ml-1 mb-n1">版本发布信息</span>
        </div>
        <v-card-text>
          <v-form ref="form" class="px-15 mt-8">
            <v-text-field
              v-model="version"
              label="版本号 *"
              color="purple lighten-1"
              :rules="[
                v => !!v || '版本号不能为空',
                v =>
                  /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(v) ||
                  '版本号格式不正确,最多输入两位小数',
              ]"
              hint="请输入版本号"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" dark @click.stop="handlePublish">提交</v-btn>
          <v-btn color="gray" @click.stop="dialogStatus = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  listThirdPartySoft,
  publishThirdPartySoft,
  delThirdPartySoft,
  updateThirdPartySoftVersion,
} from '@/api/course/thirdPartySoft';
import { listSimulationByCourse } from '@/api/simulation';
import Pagination from '@/components/Pagination/index';
import moment from 'moment';
import Swal from 'sweetalert2';
import ModelCheckDialog from '@/components/Cards/ModelCheckDialog';
import ExamConfigDialog from '@/components/Cards/ExamConfigDialog';
import {
  queryModelByCourseId,
  queryLimitPropertyModelList,
} from '@/api/model_resource';

export default {
  components: {
    Pagination,
    ModelCheckDialog,
    ExamConfigDialog,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },

  watch: {},
  data() {
    return {
      search: '',
      currentCourseId: '',
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      treeData: [],
      dialogStatus: false,
      userTableData: [],
      thirdPartySoftList: [],
      thirdPartySoftListLoading: false,
      queryParams: {},
      optionsValue: ['all'],
      displayModels: [],
      totalModels: 0,
      modelPage: 1,
      perPage: 10,
      selectedModels: [],
      editList: [
        {
          title: '发布',
          type: 'publish',
        },
        {
          title: '修改',
          type: 'edit',
        },
        {
          title: '删除',
          type: 'delete',
        },
      ],
      scoureImg: require('/public/img/log.png'),
      course: {},
      version: '',
      checkSoft: {},
      dialogModel: false,
      dialogExamConfig: false,
    };
  },
  methods: {
    queryModelData(params) {
      return queryModelByCourseId(params);
    },
    handleModel(item) {
      this.dialogModel = true;
      this.currentCourseId = item._id;
    },
    handleExamConfig(item) {
      this.dialogExamConfig = true;
      this.treeData = item.courseTree;
    },
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.page = 1;
        this.queryData();
      }
    },

    async queryData() {
      this.thirdPartySoftListLoading = true;
      let _this = this;
      let params = {
        currentPage: _this.pagination.page,
        perPage: _this.pagination.itemsPerPage,
        name: _this.search || '',
      };

      const res = await listThirdPartySoft(params);
      this.thirdPartySoftList = res.data.rows;
      this.pagination.total = res.data.total;
      this.thirdPartySoftListLoading = false;
    },
    goToSetting(item, items) {
      this.course = item;
      switch (items.type) {
        case 'edit':
          this.handleEdit(item);
          break;
        case 'delete':
          this.handleDelete(item);
          break;
        case 'publish':
          this.handleOpenPublishDialog(item);
          break;
      }
    },
    handleEdit(item) {
      this.$router.push({
        path: `/thirdPartySoft/${item._id}`,
      }); // 页面跳转
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 记录被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        const delResult = await delThirdPartySoft(item);
        if (delResult.code == 200) {
          this.pagination.page = 1;
          this.queryData();
          Swal.fire({
            title: '已删除!',
            text: `您已经删除 ${item.name}`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false,
          });
        }
      }
    },

    goToCoureDetail(item) {
      this.$router.push({
        name: 'designDetail',
        query: {
          detailId: item._id,
        },
      });
    },
    handlePublish() {
      publishThirdPartySoft({
        _id: this.checkSoft._id,
        version: this.version,
      }).then(() => {
        this.dialogStatus = false;
        this.version = '';
        this.$notify({
          timeout: 1500,
          message: '提交发布申请成功',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'success',
        });
      });
    },
    handleOpenPublishDialog(item) {
      this.dialogStatus = true;
      this.checkSoft = item;
    },
    handleOpenUpdateDialog(item) {
      updateThirdPartySoftVersion({
        _id: item._id,
      }).then((res) => {
        if (res.code == 200) {
          this.$notify({
            message: '更新成功',
            type: 'success',
            duration: 1500,
            horizontalAlign: 'center',
            verticalAlign: 'top',
          });
        } else {
          this.$notify({
            message: '更新失败，请联系技术支持',
            type: 'error',
            duration: 1500,
            horizontalAlign: 'center',
            verticalAlign: 'top',
          });
        }
      });
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },
  created() {
    this.queryData();
  },
  mounted() {
    this.thirdPartySoftListLoading = true;
  },
};
</script>

<style scoped>
.pubcollect {
  margin-right: 10px;
}
.courseWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-top: 10px;
  min-height: 580px;
  position: relative;
}

.thirdPartySoftList:hover .coureListImg {
  opacity: 0.8;
}

.coureListImg >>> .v-image__image {
  background-size: 100% 100% !important;
}

.thirdPartySoftList:hover .editWrap {
  margin: auto;
  width: 100%;
  height: 190px;
  top: 0px;
  background: #000000a3;
  display: block;
}
.coureListImg {
  width: 100%;
  transition: 0.2s;
}

.rightTag {
  float: right;
  z-index: 99;
  width: auto;
  height: auto;
  position: absolute;
  right: 0px;
  top: 0px;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}
.selectWrapAdd:hover .selectContent {
  display: block;
}

.selectContent {
  z-index: 999999;
  position: absolute;
  top: 30px;
  right: 15px;
  width: 110px;
  height: auto;
  padding: 10px 5px;
  background: #000000a3;
  display: none;
  overflow: hidden;
  border-radius: 5px;
}
.selectContent p {
  text-align: left;
  margin: 0px;
  margin-bottom: 5px;
}
.selectContent p:hover {
  background: #343434;
}
.selectContent p span {
  color: #fff;
  font-size: 13px;
}

.coureNameWrap {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.coureNameWrap p {
  color: #000;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coureNameWrap > span {
  display: block;
  margin-right: 5px;
  float: right;
  padding: 0 5px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
}

.leftTag {
  float: left;
  width: 70%;
  text-align: left;
  padding: 10px 0;
}
.leftTag p {
  width: 100%;
  margin-bottom: 2px;
  color: #fff;
  text-indent: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  font-size: 13px;
}

.editWrap {
  position: absolute;
  width: 100%;
  height: 190px;
  line-height: 40px;
  transition: 0.5s;
  top: 0px;
  text-align: right;
  display: none;
  transition: 0.5s;
}

.editWrap > span {
  display: inline-block;
  transform: translateY(130px);
}
.editWrap > span:nth-child(2) {
  margin-right: 10px;
}
.editWrap >>> svg {
  width: 1.8em !important;
  height: 1.8em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-left: 20px;
  margin-top: 20px;
  color: #fff;
  display: none;
}

.coureWraps >>> .v-card:hover .editWrap svg {
  display: inline;
}

.thirdPartySoftList {
  /* margin: 10px 0; */
  height: 245px;
  max-height: 245px;
  cursor: pointer;

  padding-right: 10px !important;
  padding-left: 10px !important;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}
.md-layout {
  min-height: 490px;
}

.pagination {
  /* margin: 0 auto; */
  margin-right: 30px;
  float: right;
  padding: 0;
  overflow: hidden;
}
.createCourse {
  /* margin: 10px 0; */
  height: 235px;
  max-height: 235px;
  cursor: pointer;
  border-radius: 4px;
  padding-right: 10px !important;
  padding-left: 10px !important;

  position: relative;
}
.createCourse .addIcon {
  position: absolute;
  top: 40px;
  left: 40px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 45px;
}

.createCourse .addText {
  position: absolute;
  bottom: 40px;
  left: 40px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 30px;
}

.iconStyle {
  font-size: 20px;
  color: red;
}

@media (max-width: 1370px) {
  .coureNameWrap p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    width: 55% !important;
  }
  .coureNameWrap .intoCourse {
    height: 20px !important;
    line-height: 20px !important;
    width: 45% !important;
  }
}
@media (max-width: 1160px) {
  .courseList {
    height: 160px !important;
  }

  .cardWrap {
    height: 160px !important;
  }

  .coureListImg {
    height: 130px !important;
  }
  .coureNameWrap {
    height: 20px !important;
    line-height: 20px !important;
  }
  .coureNameWrap p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    width: 55% !important;
  }
  .coureNameWrap .intoCourse {
    height: 20px !important;
    line-height: 20px !important;
    width: 45% !important;
  }

  .coureNameWrap .intoCourse span {
    height: 20px !important;
    line-height: 20px !important;
  }

  /* .isMobileWrap{}

.courseList{} */
}

@media (max-width: 850px) {
  .courseList {
    height: 130px !important;
  }

  .cardWrap {
    height: 130px !important;
  }

  .coureListImg {
    height: 100px !important;
  }
  .coureNameWrap {
    height: 20px !important;
    line-height: 20px !important;
  }
  .coureNameWrap p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    width: 55% !important;
    font-size: 11px;
  }
  .coureNameWrap .intoCourse {
    height: 20px !important;
    line-height: 20px !important;
    width: 45% !important;
    font-size: 11px;
  }

  .coureNameWrap .intoCourse span {
    height: 20px !important;
    line-height: 20px !important;
  }
}

@media (max-width: 750px) {
  .courseList {
    height: 100px !important;
  }

  .cardWrap {
    height: 100px !important;
  }
  .coureNameWrap {
    margin-top: 0px !important;
  }
  .coureListImg {
    height: 80px !important;
  }
  .coureNameWrap {
    height: 20px !important;
    line-height: 20px !important;
  }
  .coureNameWrap p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    font-size: 11px;
    width: 55% !important;
  }
  .coureNameWrap .intoCourse {
    height: 20px !important;
    line-height: 20px !important;
    width: 45% !important;
    font-size: 11px;
  }

  .coureNameWrap .intoCourse span {
    height: 20px !important;
    line-height: 20px !important;
  }
}
@media (max-width: 600px) {
  .thirdPartySoftListWrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 1px;
  }
  .thirdPartySoftList {
    width: 45% !important;
    height: 110px;
    margin: 8px;
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .thirdPartySoftListWrap .thirdPartySoftList:nth-child(1) {
    margin-top: 0px !important;
  }
  .thirdPartySoftListWrap .thirdPartySoftList:nth-child(2) {
    margin-top: 0px !important;
  }

  .coureNameWrap p {
    font-size: 10px;
    margin: 0px;
    line-height: 18px;
    height: 18px;
    width: 65%;
  }

  .intoCourse span {
    font-size: 8px;
  }

  .coureNameWrap .intoCourse {
    width: 35% !important;
    line-height: 18px !important;
    height: 18px !important;
  }
  .coureNameWrap .intoCourse span {
    line-height: 18px;
    font-size: 8px;
  }
  .coureNameWrap .intoCourse .intoCourseIon {
    float: right !important;
    font-size: 12px !important;
  }
  .thirdPartySoftList:hover .editWrap {
    height: 80px;
  }
  .leftTag p {
    font-size: 8px;
    text-indent: 5px;
  }
  .leftTag p span {
    font-size: 8px;
  }
  .selectContent {
    width: 90px;
  }
  .selectContent p {
    font-size: 8px;
  }
  .selectContent p span {
    font-size: 10px;
  }
  .selectContent p {
    margin-bottom: 0px;
  }

  .rightTag button {
    width: 28px !important;
  }

  .createCourse {
    /* margin: 10px 0; */
    height: 105px;
    width: 140px;
    max-height: 105px;
    cursor: pointer;
    border-radius: 4px;
    padding-right: 10px !important;
    padding-left: 10px !important;

    position: relative;
  }
  .createCourse .addIcon {
    font-size: 20px;
    left: 50px;
  }
  .createCourse .addText {
    font-size: 17px;
    top: 60px;
    left: 25px;
  }
}
</style>
